/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InhousePaymentDto } from './InhousePaymentDto';
import {
    InhousePaymentDtoFromJSON,
    InhousePaymentDtoFromJSONTyped,
    InhousePaymentDtoToJSON,
    InhousePaymentDtoToJSONTyped,
} from './InhousePaymentDto';

/**
 * 
 * @export
 * @interface PageInhousePaymentDto
 */
export interface PageInhousePaymentDto {
    /**
     * 
     * @type {number}
     * @memberof PageInhousePaymentDto
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof PageInhousePaymentDto
     */
    totalElements: number;
    /**
     * 
     * @type {number}
     * @memberof PageInhousePaymentDto
     */
    numberOfElements: number;
    /**
     * 
     * @type {number}
     * @memberof PageInhousePaymentDto
     */
    currentPageNo: number;
    /**
     * 
     * @type {number}
     * @memberof PageInhousePaymentDto
     */
    pageSize: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageInhousePaymentDto
     */
    isFirst: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageInhousePaymentDto
     */
    isLast: boolean;
    /**
     * 
     * @type {Array<InhousePaymentDto>}
     * @memberof PageInhousePaymentDto
     */
    pageContent: Array<InhousePaymentDto>;
}

/**
 * Check if a given object implements the PageInhousePaymentDto interface.
 */
export function instanceOfPageInhousePaymentDto(value: object): value is PageInhousePaymentDto {
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('numberOfElements' in value) || value['numberOfElements'] === undefined) return false;
    if (!('currentPageNo' in value) || value['currentPageNo'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    if (!('isFirst' in value) || value['isFirst'] === undefined) return false;
    if (!('isLast' in value) || value['isLast'] === undefined) return false;
    if (!('pageContent' in value) || value['pageContent'] === undefined) return false;
    return true;
}

export function PageInhousePaymentDtoFromJSON(json: any): PageInhousePaymentDto {
    return PageInhousePaymentDtoFromJSONTyped(json, false);
}

export function PageInhousePaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageInhousePaymentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
        'totalElements': json['totalElements'],
        'numberOfElements': json['numberOfElements'],
        'currentPageNo': json['currentPageNo'],
        'pageSize': json['pageSize'],
        'isFirst': json['isFirst'],
        'isLast': json['isLast'],
        'pageContent': ((json['pageContent'] as Array<any>).map(InhousePaymentDtoFromJSON)),
    };
}

export function PageInhousePaymentDtoToJSON(json: any): PageInhousePaymentDto {
    return PageInhousePaymentDtoToJSONTyped(json, false);
}

export function PageInhousePaymentDtoToJSONTyped(value?: PageInhousePaymentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['totalPages'],
        'totalElements': value['totalElements'],
        'numberOfElements': value['numberOfElements'],
        'currentPageNo': value['currentPageNo'],
        'pageSize': value['pageSize'],
        'isFirst': value['isFirst'],
        'isLast': value['isLast'],
        'pageContent': ((value['pageContent'] as Array<any>).map(InhousePaymentDtoToJSON)),
    };
}

